module.exports = __webpack_public_path__ + "d98da3cd5e11d61262f4542ca5facea9.svg";